import { render, staticRenderFns } from "./DiscountsTicket.vue?vue&type=template&id=1a903076&scoped=true&"
import script from "./DiscountsTicket.vue?vue&type=script&lang=js&"
export * from "./DiscountsTicket.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsTicket.vue?vue&type=style&index=0&id=1a903076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a903076",
  null
  
)

export default component.exports